import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import DonateImage from "./Donate.png";
import JSAPImage from "./JSAP.png";
import SAPImage from "./SAP.png";
import Test from "./testimony.png";
/* eslint-disable */
function MainContent() {
  return (
    <div
      className="mt-5 mb-5 container"
      style={{
        fontFamily: "Jost, sans-serif",
        maxWidth: "1300px",
      }}
    >
      {/* Carousel */}
      <div
        className="shadow"
        style={{
          overflow: "hidden",
          borderRadius: "60px",
          marginBottom: "30px",
        }}
      >
        <Carousel>
          <Carousel.Item className="text-dark">
            <img
              className="d-block w-100"
              src={SAPImage}
              alt="Student Assistance Program"
              style={{ height: "400px", objectFit: "cover" }}
            />
            <Carousel.Caption>
              <h3></h3>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={JSAPImage}
              alt="Job Search Assistance Program"
              style={{ height: "400px", objectFit: "cover" }}
            />
            <Carousel.Caption>
              <h3></h3>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={DonateImage}
              alt="Donate to Community Center"
              style={{ height: "400px", objectFit: "cover" }}
            />
            <Carousel.Caption>
              <h3></h3>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>

      {/* Rounded Container for Content */}
      <div
        className="rounded bg-light p-4 mt-4"
        style={{
          borderRadius: "60px",
        }}
      >
        {/* Paragraph */}
        <div className="mb-4">
          <h2 className="fw-bold text-center">About Our Organization</h2>
          <p className="fs-5 text-center">
            Welcome to our organization! We offer a variety of activities,
            events, and programs to engage our community. Whether you're
            interested in sports, cultural activities, or volunteering, there's
            something for everyone.
          </p>
        </div>

        {/* Rounded Boxes */}
        <div className="row g-3">
          {/* Box 1 */}
          <div className="col-12 col-md-4">
            <div className="shadow p-4 bg-white rounded text-center">
              <h3>Events</h3>
              <p>
                Explore our upcoming events designed to bring people together.
              </p>
            </div>
          </div>
          {/* Box 2 */}
          <div className="col-12 col-md-4">
            <div className="shadow p-4 bg-white rounded text-center">
              <h3>Sports</h3>
              <p>Join our sports programs and enjoy recreational activities.</p>
            </div>
          </div>
          {/* Box 3 */}
          <div className="col-12 col-md-4">
            <div className="shadow p-4 bg-white rounded text-center">
              <h3>Activities</h3>
              <p>
                Participate in cultural, educational, and community programs.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Testimony Section */}
      <div
        className="shadow mt-4 p-4 bg-white rounded"
        style={{
          borderRadius: "30px",
        }}
      >
        <h2 className="text-center fw-bold mb-4">Success Stories</h2>
        <div className="row justify-content-center g-3">
          <div className="col-12 col-md-8 d-flex align-items-center bg-light p-3 rounded">
            <img
              src={Test}
              alt="Testimonial"
              className="rounded-circle me-3"
              style={{ width: "80px", height: "80px" }}
            />
            <div>
              <h5 className="fw-bold mb-1">Faiz</h5>
              <p className="mb-0">
                "When I first arrived in the country, everything felt unfamiliar
                and overwhelming. But thankfully, I wasn’t alone for long. I
                received incredible support that helped me find my
                footing—whether it was understanding local systems, finding a
                place to stay, or simply being welcomed with kindness. That
                initial help meant the world to me and made my transition so
                much smoother. I will always be grateful for that support."
              </p>
            </div>
          </div>
          <div className="col-12 col-md-8 d-flex align-items-center bg-light p-3 rounded">
            <img
              src={Test}
              alt="Testimonial"
              className="rounded-circle me-3"
              style={{ width: "80px", height: "80px" }}
            />
            <div>
              <h5 className="fw-bold mb-1">Abaan</h5>
              <p className="mb-0">
                "Moving to a new country was a big change, and I was afraid I’d
                feel isolated. But finding a community here changed everything.
                I met people who understand, support, and uplift me—and because
                of them, I have never truly felt alone. This sense of belonging
                has made this new place feel like home."
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Join Us Section */}
      <div
        className="rounded bg-white p-4 mt-4 shadow"
        style={{
          borderRadius: "15px",
        }}
      >
        <h3 className="text-center">Join Our Community</h3>
        <div className="mt-3">
          <p className="text-center">
            Be part of a thriving and supportive community that embraces growth,
            connection, and shared opportunities. By joining us, you’ll gain
            access to exclusive events, valuable resources, and a network of
            inspiring individuals who are committed to making a meaningful
            difference in society.
          </p>
        </div>
        <div className="text-center">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSf2KMAFJHeSqzbwO5m1ewpBVIkdXfS9eSS4jigiHkctHBVYyw/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success text-white"
          >
            Join <i className="bi bi-chevron-right"></i>
          </a>
        </div>
      </div>

      {/* Contact Us Section */}
      <div
        className="shadow mt-4 p-4 bg-white rounded"
        style={{
          borderRadius: "30px",
        }}
      >
        <h2 className="text-center fw-bold mb-4">Contact Us</h2>
        <p className="text-center">
          Have questions or want to learn more? Reach out to us at (49)
          456-7890. We look forward to hearing from you!
        </p>
      </div>
    </div>
  );
}

export default MainContent;
